export default __webpack_public_path__ + "static/media/ic-crops-grain.25459c19.svg";